import { render, staticRenderFns } from "./FeaturedDetail.vue?vue&type=template&id=7d92124d&"
import script from "./FeaturedDetail.vue?vue&type=script&lang=js&"
export * from "./FeaturedDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports